var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeynote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.472,
    height: 18.596,
    viewBox: "0 0 19.472 18.596",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27098",
    "data-name": "Group 27098",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27084",
    "data-name": "Group 27084",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27083",
    "data-name": "Group 27083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10669",
    "data-name": "Path 10669",
    d: "M174.938,121.051h-1.886a.789.789,0,1,0,0,1.579h1.886a.758.758,0,0,0,.746-.781v-.017A.758.758,0,0,0,174.938,121.051ZM189.893,105H173.579A1.579,1.579,0,0,0,172,106.579V117.1a1.579,1.579,0,0,0,1.579,1.579h16.314a1.579,1.579,0,0,0,1.579-1.579V106.579A1.579,1.579,0,0,0,189.893,105Zm-8.157,3.158a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,181.736,108.158Zm3.2,7.422a.456.456,0,0,1-.438.472h-5.521a.456.456,0,0,1-.438-.472v-.448a1.5,1.5,0,0,1,1.44-1.551h3.517a1.5,1.5,0,0,1,1.44,1.551Zm5.485,5.471h-7.675a.758.758,0,0,0-.746.781v.017a.758.758,0,0,0,.746.781h7.675a.789.789,0,0,0,0-1.579Z",
    transform: "translate(-172 -105)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1219",
    "data-name": "Ellipse 1219",
    cx: 0.784,
    cy: 1.568,
    rx: 0.784,
    ry: 1.568,
    transform: "translate(6.36 15.46)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeynote);
export default __webpack_public_path__ + "static/media/keynote.6682f0a992b24a83aefa9d2eb1c5086a.svg";
export { ForwardRef as ReactComponent };